import React from "react";
import styles from "./Inicio.module.css";


function Inicio() {
    return (
        <div className={styles["inicio"]}>
            
           
            
            <main className={styles["main-content"]}>
                <h2>Sobre o App</h2>
                <p>Este aplicativo foi criado para facilitar suas tarefas diárias e melhorar sua produtividade.</p>
                <p>Navegue pelas páginas para explorar mais funcionalidades!</p>
                <a href="/Vendas" className={styles["btn"]}>Entrar no App</a>
            </main>

            
            
        </div>
    );
}

export default Inicio;
